import Ripple from '../../../es/ripple';
export default Ripple;
